import { Row, Col, Card, Spinner } from 'react-bootstrap'
import { useAdminAnalyticsSummary } from 'api/hooks/use-admin-analytics'

// Turns a duration in seconds into a compact, human-readable label
// (e.g. 95 -> "1m 35s", 3700 -> "1h 1m"). Returns undefined when there is no
// value so the card falls back to its "--" placeholder.
const formatDuration = (seconds) => {
  if (seconds == null) {
    return undefined
  }

  const total = Math.round(seconds)
  if (total < 60) {
    return `${total}s`
  }

  const minutes = Math.floor(total / 60)
  if (minutes < 60) {
    const remSeconds = total % 60
    return remSeconds ? `${minutes}m ${remSeconds}s` : `${minutes}m`
  }

  const hours = Math.floor(minutes / 60)
  const remMinutes = minutes % 60
  return remMinutes ? `${hours}h ${remMinutes}m` : `${hours}h`
}

const StatCard = ({ title, value, isLoading }) => (
  <Card className="h-100">
    <Card.Body className="text-center">
      <Card.Title className="text-muted fs-6">{title}</Card.Title>
      <div className="fs-2 fw-bold">
        {isLoading ? <Spinner size="sm" /> : value?.toLocaleString() ?? '--'}
      </div>
    </Card.Body>
  </Card>
)

const SummaryCards = ({ params }) => {
  const { data, isLoading } = useAdminAnalyticsSummary({ params })

  return (
    <Row className="mb-4">
      <Col md className="mb-3">
        <StatCard title="Total Visits" value={data?.total_visits} isLoading={isLoading} />
      </Col>
      <Col md className="mb-3">
        <StatCard title="Unique Visitors" value={data?.unique_visitors} isLoading={isLoading} />
      </Col>
      <Col md className="mb-3">
        <StatCard title="Total Events" value={data?.total_events} isLoading={isLoading} />
      </Col>
      <Col md className="mb-3">
        <StatCard title="Page Views" value={data?.total_page_views} isLoading={isLoading} />
      </Col>
      <Col md className="mb-3">
        <StatCard title="Avg Events/Visit" value={data?.avg_events_per_visit} isLoading={isLoading} />
      </Col>
      <Col md className="mb-3">
        <StatCard title="Avg Session" value={formatDuration(data?.avg_session_duration)} isLoading={isLoading} />
      </Col>
    </Row>
  )
}

export default SummaryCards
